module.exports = __webpack_public_path__ + "img/b.5536c5ee.jpg";